import { Component, computed, inject } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { TranslatePipe } from '@ngx-translate/core';
import { I18nService } from '@core/config/i18n/i18n.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-language-selector',
  imports: [MatSelectModule, MatIconModule, TranslatePipe],
  templateUrl: './language-selector.html',
  styleUrl: './language-selector.scss',
})
export class LanguageSelector {
  protected readonly i18n = inject(I18nService);

  protected readonly selectedLanguageLabelKey = computed(() =>
    this.i18n.supportedLanguages.find((lang) => lang.code === this.i18n.currentLang())?.labelKey
  );

  protected onLanguageChange(langCode: string): void {
    this.i18n.setLanguage(langCode);
  }
}
